import React, { useState, useEffect } from 'react';
import { ListLayout } from '../../containers/Layout';
import { TableHead, TableBody, TableRow, TableCell, Button, IconButton, Box, Grid, Tooltip } from '@material-ui/core';
import { AddRounded, CheckRounded, CloseRounded, DeleteRounded, AddBoxRounded, CheckBoxRounded } from '@material-ui/icons';
import { isEmpty, size } from 'lodash';
import ClientPopUp from '../../clients/ClientPopUp';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';
import DeleteDialogConfirm from '../../../../../commonModules/interface/DeleteDialogConfirm';
import { toast } from 'react-toastify';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';

const ListTransferInstall = (props) => {
    const [breadcrumb, setBreadcrumb] = useState('');
    const [deletePopUp, setDeletePopUp] = useState(false);
    const [toDeleteClient, setToDeleteClient] = useState('');
    const [toDelete, setToDelete] = useState({
        id: '',
    });
    const [view, setView] = useState('list');
    const [clientPopUp, setClientPopUp] = useState(false);
    const [client, setClient] = useState({});
    const fetchTransfers = useFetchTransfers("installation");
    
    useEffect(() => {
        console.log('MOUNTING ListTransferInstalls ');
        if(isEmpty(props.INSTALLS)){
            fetchTransfers();
        }
    }, []);

    const createInstallList = (list) => {
        const { SHOPS, CLIENTS, rowsPerPage, currentPage, handleSingleShop, handleSingleInstall, handleInstallToSale } = props;

        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((install) => {
            if (install) {
                const client = CLIENTS[install.client_id];
                let client_name = client ? `${client.client_firstname} ${client.client_lastname}` : '';
                const shop = SHOPS[install.shop_id];

                return (
                    <TableRow key={install.id}>
                        <TableCell>{new Date(install.creation_date).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                            {shop ? (
                                <a href="#" onClick={() => handleSingleShop(shop)}>
                                    {' '}
                                    {shop.name}{' '}
                                </a>
                            ) : (
                                <span>{install.shop_id}</span>
                            )}
                        </TableCell>
                        <TableCell>
                            {client && (
                                <a href="#" onClick={() => {setClient(client) ; setClientPopUp(true)}}>
                                    {client_name}
                                </a>
                            )}
                        </TableCell>
                        <TableCell>
                            <IconButton color="secondary" onClick={() => handleSingleInstall(install, shop, client)}>
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        {/* <TableCell>
                            <Tooltip placement="top" title="Compléter">
                                <IconButton onClick={() => handleInstallToSale(install, client)}>
                                    <CheckBoxRounded color="primary" />
                                </IconButton>
                            </Tooltip>
                        </TableCell> */}
                        <TableCell>
                            {!install.received &&
                                <Tooltip placement="top" title="Annuler">
                                    <IconButton
                                        onClick={() => {
                                            setToDelete(install);
                                            setToDeleteClient(client_name);
                                            setDeletePopUp(true);
                                        }}
                                    >
                                        <CloseRounded color="error" />
                                    </IconButton>
                                </Tooltip>
                            }
                        </TableCell>
                    </TableRow>
                );
            }
        });
    };

    const displayList = () => {
        const { INSTALLS, getFilteredList } = props;
        let tab = [];
        let rows = 0;
        if (!isEmpty(INSTALLS)) {
            let filteredList = getFilteredList();
            rows = size(filteredList);
            tab = createInstallList(filteredList);
        }
        return [tab, rows];
    };

    const deleteInstall = async (comments) => {
        let data = {
            id: toDelete.id,
            comments,
        };
        try{
            const resp = await props.deleteInstall(data);
            toast.success('Installation supprimée avec succès');
            setDeletePopUp(false);
            setToDelete({ id: '' });
        }catch(err){
            console.log('[ERROR] delete install', err.message);
            toast.error('Un Problème est survenu'+err.message);
        }
    };

  return (
    <Box>
        {deletePopUp && (
            <DeleteDialogConfirm
                open={true}
                close={() => setDeletePopUp(false)}
                title={`l'installation pour ${toDeleteClient}`}
                handleSubmit={deleteInstall}
                disabledSubmit={props.STATE.installs.fetching}
            />
        )}
        {clientPopUp && !isEmpty(client) && (
            <ClientPopUp client={client} {...props} closePopUp={() => setClientPopUp(false, { client: {} })} />
        )}

      {view === 'list' && (
        <Box>
            <ListLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Shop</TableCell>
                            <TableCell>Nom Client</TableCell>
                            <TableCell>Détails</TableCell>
                            {/* <TableCell>Compléter</TableCell> */}
                            <TableCell>Annuler</TableCell>
                        </TableRow>
                    </TableHead>
                <TableBody>
                    {displayList()[1] !== 0 && displayList()[0]}
                    {displayList()[1] === 0 && (
                        <TableRow>
                        <TableCell colSpan={5}>
                            <div className="text-center">
                            <h5>Pas encore d'Installation</h5>
                            Cliquez sur <b className="onglet">"Nouveau"</b> Pour créer une nouvelle Installation
                            </div>
                        </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {displayList()[1] > 20 && (
                    <TableFooterPagination
                        colSpan={7}
                        count={displayList()[1]}
                        onChangePage={props.onChangePage}
                        initialPage={props.currentPage || 0}
                        page={props.currentPage}
                    />
                )}
            </ListLayout>
        </Box>
      )}
    </Box>
  );
};

export default ListTransferInstall;
